import { useState } from "react";
import CustomButton from "../components/CustomButton";

export default function Contact(){
    const [firstname, setFirstname] = useState("");
    const [lastname, setLastname] = useState("");
    const [email, setEmail] = useState("");
    const [content, setContent] = useState("");

    const postContact = async ( firstname, lastname, email, content ) => {
        try {
            const response = await fetch("https://imajin.dev/api/create-a-page-contact", {
                method: "POST",
                headers: {
                "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    firstname, lastname, email, content
                }),
            });
        
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
        
            console.log("Comment posted successfully");
        } catch (error) {
            console.error("Error posting comment:", error.message);
        }
    }

    const handleSubmit = () => {
        if (!firstname || !lastname || !email || !content ) {
            alert("All fields are required");
            return;
        }

        console.log('submit');

        postContact( firstname, lastname, email, content );

        setFirstname("");
        setLastname("");
        setEmail("");
        setContent("");
    }

    return(
        <div className = "page">
            <h2>Contact</h2>
            <p>You can always email or DM too, but this is the fastest route! I usually respond back in 3 days.</p>
            
            <br/>
            <br/>

            <div className = "contactContainer">
                <h3>Name</h3>
                <input
                    value = { firstname }
                    onChange = { (e) => setFirstname(e.target.value) }
                    type = "text"
                    placeholder = "First Name"
                />
                <input style = { { marginLeft : "16px"} }
                    value = { lastname }
                    onChange = { (e) => setLastname(e.target.value) }
                    type = "text"
                    placeholder = "Last Name"
                />
            </div>

            <div className = "contactContainer">
                <h3>Email</h3>
                <input
                        value = { email }
                        onChange = { (e) => setEmail(e.target.value) }
                        type = "text"
                        placeholder = "Email"
                />
            </div>

            <div className = "contactContainer">
                <h3>How Can I Help?</h3>
                <textarea style = { { height : "160px" } }
                        value = { content }
                        onChange = { (e) => setContent(e.target.value) }
                        type = "text"
                        placeholder = "I like to learn about.."
                />
            </div>

            <div style = { { display : "flex", justifyContent : "flex-end" } }>
                <CustomButton text = "Send" color = "0, 0, 0" onClick = { handleSubmit }/>
            </div>

        </div>
    )
}